export interface AccountsSearch {
  connected?: string | undefined;
  error?: string | undefined;
  /** The calendar consent round trip: `?calendarConnected=<email>` or `?calendarError=<code>`. */
  calendarConnected?: string | undefined;
  calendarError?: string | undefined;
}

/**
 * `/accounts?connected=<email>` or `/accounts?error=<code>` after Google's Gmail redirect, and
 * `?calendarConnected=` / `?calendarError=` after the calendar consent redirect.
 */
export function parseAccountsSearch(raw: Record<string, unknown>): AccountsSearch {
  const pick = (v: unknown) =>
    typeof v === "string" && v.trim() ? v.trim().slice(0, 200) : undefined;
  return {
    connected: pick(raw.connected),
    error: pick(raw.error),
    calendarConnected: pick(raw.calendarConnected),
    calendarError: pick(raw.calendarError),
  };
}
